/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Barcode_DescInputs */

const vi_mobile_scan_barcode_desc = /** @type {(inputs: Mobile_Scan_Barcode_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng camera vào mã vạch sản phẩm để thêm vào đơn hàng.`)
};

/**

* @param {Mobile_Scan_Barcode_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_barcode_desc = /** @type {((inputs?: Mobile_Scan_Barcode_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Barcode_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_scan_barcode_desc(inputs)
});